module.exports = __webpack_public_path__ + "img/lezhi05.a2e2c215.png";